<template>
  <div class="lesson">
	<!-- dialog -->
	<v-dialog v-model="dialog.show" max-width="380" content-class="rounded-xl">
		<v-card class="rounded-xl pa-4">
			<v-list-item dense three-line class="pa-0">
				<v-list-item-avatar
					tile
					size="55"
					color="myBlue"
					class="align-self-center rounded-lg me-2 my-2"
				>
					<v-img
						class="align-center rounded-0"
						src="@/assets/homework1.png"
						max-width="35"
						max-height="35"
					/>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title class="title homeBlue--text mb-0">
						{{ dialog.subjectName }}
					</v-list-item-title>

					<v-list-item-subtitle class="text-subtitle-1">
						{{ dialog.teacherName }}
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-list-item>
				<v-list-item-content class="pt-0">
					<v-list-item-title class="text-h5 homeBlue--text">
						الدرس:
					</v-list-item-title>
					<v-list-item-subtitle class="title black--text text-pre-line mb-1">
						{{ dialog.notes || '-' }}
					</v-list-item-subtitle>
				
					<v-list-item-title class="text-h5 homeBlue--text">
						تفاصيل  الدرس:
					</v-list-item-title>
					<v-list-item-subtitle class="title black--text text-pre-line">
						{{ dialog.details }}
					</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-row>
				<v-spacer></v-spacer>
				<v-col cols="auto">
					<v-btn
						height="30"
						text
						color="white"
						class="rounded myBlue caption"
						@click="dialog.show = false"
					>
						اغلاق
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>

	<v-container fluid>
		<div>
			<div class="mb-2 d-flex flex-row align-center justify-space-between ">
				<v-btn
					class="ms-2"
					icon
					@click="month = moment(month).subtract(1, 'month').format('YYYY-MM')"
				>
					<v-icon>mdi-chevron-right</v-icon>
				</v-btn>
				<span class="title myBlue--text">{{moment(month).locale('ar-ly').format('MMMM YYYY')}}</span>
				<v-btn
					class="me-2"
					icon
					@click="month = moment(month).add(1, 'month').format('YYYY-MM')"
				>
					<v-icon>mdi-chevron-left</v-icon>
				</v-btn>
			</div>
			<VMonthDays
				v-model="date"
				:month="month"
				color="white"
				@input="getLessons()"
			/>
		</div>

		<div
			v-if="loading"
			class="d-flex justify-center align-center"
			style="height: 60vh"
		>
			<v-progress-circular indeterminate color="primary"/>
		</div>

		<div v-else class="mt-4">
			<v-card
				class="rounded-xl mb-2"
				v-for="lesson in lessons"
				:key="lesson.id"
			>
				<v-list-item dense three-line>
					<v-list-item-avatar
						tile
						size="55"
						color="myBlue"
						class="align-self-center rounded-lg my-1 me-2"
					>
						<v-img
							class="align-center rounded-0"
							src="@/assets/homework1.png"
							max-width="35"
							max-height="35"
						></v-img>
					</v-list-item-avatar>
		
					<v-list-item-content class="py-2">
						<v-list-item-title class="mb-0">
							<v-row dense>
								<v-col>
									<span class="homeBlue--text title"> {{ lesson.SubjectName }} </span>
								</v-col>
								<v-spacer></v-spacer>
								<v-col>
									<v-btn
										height="30"
										text
										color="white"
										class="rounded myBlue text-caption"
										@click="openDialog(lesson)"
									>
										تفاصيل الدرس
									</v-btn>
								</v-col>
							</v-row>
						</v-list-item-title>
		
						<v-list-item-subtitle class="text-subtitle-1">
							{{ lesson.TeacherName }}
						</v-list-item-subtitle>

						<v-list-item-title class="font-weight-regular text-subtitle-2 text-pre-line my-1">
							<strong>الدرس:</strong>
							<div class="grey--text text--darken-2 mt-1">{{lesson.Notes || '-'}}</div>
						</v-list-item-title>

						<v-list-item-title
							v-if="lesson.Details"
							class="font-weight-regular text-subtitle-2 text-pre-line my-1"
						>
							<strong>تفاصيل الدرس:</strong>
							<div class="grey--text text--darken-2 mt-1">{{lesson.Details}}</div>
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-card>
			
			<div v-if="!lessons.length" class="text-center mt-13">
				لا يوجد دروس
			</div>
		</div>
	</v-container>
  </div>
</template>

<script>
import VMonthDays from '@/components/VMonthDays.vue'
import moment from '@/moment';
import { mapState } from 'vuex';

export default {
	name: 'LessonView',
	components: { VMonthDays },
	
	data () {
		return {
			date: moment().format('YYYY-MM-DD'),
			loading: false,
			moment,
			dialog: {
				show: false,
				subjectName: '',
				teacherName: '',
				details: '',
				notes: ''
			},
			month: moment().format('YYYY-MM'),
			fromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			toDate: moment().add(7, 'days').format('YYYY-MM-DD'),
		}
	},

	computed: {
		...mapState({
			lessons: (state) => state.lessons.lessons,
		}),
	},

	methods: {
		openDialog(lesson) {
			this.dialog.show = true
			this.dialog.subjectName = lesson.SubjectName
			this.dialog.teacherName = lesson.TeacherName
			this.dialog.details = lesson.Details
			this.dialog.notes = lesson.Notes
		},

		getDiffText(date) {
			const diff = moment(date).diff(moment(), 'days');
			if (diff > 0) return `(${moment(date).diff(moment(), 'days')} يوم متبقي)`
			else if (diff === 0) return '(متبقى أقل من يوم)'
			else return '(انتهى موعد التسليم)'
		},

		getLessons() {
			this.loading = true
			return this.$store.dispatch('lessons/fetchAll', {
				fromDate: this.date,
				toDate: this.date
			}).finally(() => { this.loading = false });
		},
	},

	created() {
		this.getLessons();
	}
}
</script>

<style lang='scss'>
.sticky {
	position: fixed;
	z-index: 2;
}
</style>